let ENDPOINT = "ws://localhost:8765/";
let ws;
let connected = false;

export function connect_barcodescanner() {
  if (process.env.VUE_APP_DISABLE_BARCODE_SCANNER === "1") return;

  if (!connected) connect();
  connected = true;
}

function connect() {
  ws = new WebSocket(ENDPOINT);
  ws.onopen = () => {
    console.log("barcode websocket opened");
  };

  ws.onmessage = event => {
    console.log("barcode websocket received: " + event.data);
    let barcode = JSON.parse(event.data);
    window.global_event_bus.$emit("barcodeScanned", barcode);
  };

  ws.onclose = event => {
    console.log("barcode websocket closed (" + event.code + ")");
    setTimeout(() => {
      connect();
    }, 5000);
  };

  ws.onerror = error => {
    console.log("barcode websocket error: " + error.message);
    ws.close();
  };
}
